exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-popup{opacity:1!important}.info-popup .tooltip-inner{background:#fff;color:#2c3e38;font-size:.7rem;line-height:.9rem;border:1px solid #e5ecf0}.info-popup .arrow:before{border-top-color:#fff}", ""]);

// exports
